import React from 'react';

const AddAdminModal = ({ 
  adminForm, 
  formErrors, 
  actionLoading, 
  onInputChange, 
  onSubmit, 
  onClose,
  roles = [],
  loadingRoles = false
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">Invite New User</h3>
        <form onSubmit={onSubmit}>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                First Name *
              </label>
              <input
                type="text"
                name="firstName"
                value={adminForm.firstName}
                onChange={onInputChange}
                className={`w-full border rounded-md p-2 text-sm ${
                  formErrors.firstName ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Enter first name"
              />
              {formErrors.firstName && (
                <p className="text-red-500 text-xs mt-1">{formErrors.firstName}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Last Name *
              </label>
              <input
                type="text"
                name="lastName"
                value={adminForm.lastName}
                onChange={onInputChange}
                className={`w-full border rounded-md p-2 text-sm ${
                  formErrors.lastName ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Enter last name"
              />
              {formErrors.lastName && (
                <p className="text-red-500 text-xs mt-1">{formErrors.lastName}</p>
              )}
            </div>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email Address *
            </label>
            <input
              type="email"
              name="email"
              value={adminForm.email}
              onChange={onInputChange}
              className={`w-full border rounded-md p-2 text-sm ${
                formErrors.email ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Enter email address"
            />
            {formErrors.email && (
              <p className="text-red-500 text-xs mt-1">{formErrors.email}</p>
            )}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Role *
            </label>
            <select
              name="roleId"
              value={adminForm.roleId}
              onChange={onInputChange}
              className={`w-full border rounded-md p-2 text-sm ${
                formErrors.roleId ? 'border-red-500' : 'border-gray-300'
              }`}
              disabled={loadingRoles}
            >
              <option value="">Select a role</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name.charAt(0).toUpperCase() + role.name.slice(1)}
                </option>
              ))}
            </select>
            {loadingRoles && (
              <p className="text-xs text-gray-500 mt-1">Loading roles...</p>
            )}
            {formErrors.roleId && (
              <p className="text-red-500 text-xs mt-1">{formErrors.roleId}</p>
            )}
          </div>
          <div className="bg-blue-50 p-3 rounded-md mb-4">
            <p className="text-sm text-blue-700">
              <strong>Note:</strong> A secure password will be auto-generated and sent to the user's email address.
              The user will be required to change their password on first login.
            </p>
          </div>
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:text-gray-800"
              disabled={actionLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50"
              disabled={actionLoading || loadingRoles}
            >
              {actionLoading ? 'Sending Invitation...' : 'Send Invitation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAdminModal;